import HttpService from "./htttp.service"; // make sure spelling is correct

class CenterService {
  endpoint = 'centers';

  getAll = async () => {
    return await HttpService.get(`${this.endpoint}/`);
  };

  get = async (id) => {
    return await HttpService.get(`${this.endpoint}/${id}`);
  };

  create = async (payload) => {
    return await HttpService.post(`${this.endpoint}/add`, payload);
  };

  update = async (id, payload) => {
    return await HttpService.put(`${this.endpoint}/${id}`, payload);
  }

  delete = async (id) => {
    // ✅ Do NOT send a body, just call delete with URL
    return await HttpService.delete(`${this.endpoint}/${id}`);
  }
}

export default new CenterService();
